/** Product of the walkthrough queue as far as a shared link cares. */
export interface LinkableProduct {
  id: string;
  artNumber?: string | null;
}

/** The SKU a link shows for a product; the id stands in where it has none. */
export function linkSku(product: LinkableProduct): string {
  return product.artNumber || product.id;
}

/**
 * Which product of the queue a shared link points at. The SKU narrows the
 * queue down; several products can share a SKU, so the mockup id decides
 * between them (only those candidates' templates are loaded). Returns -1
 * when nothing matches.
 */
export async function resolveLinkedProduct(
  products: readonly LinkableProduct[],
  sku: string,
  mockupId: string | null,
  loadTemplateIds: (productId: string) => Promise<readonly string[]>
): Promise<number> {
  const candidates = products
    .map((product, index) => ({ product, index }))
    .filter(({ product }) => linkSku(product) === sku);
  if (candidates.length === 0) return -1;
  if (candidates.length === 1 || !mockupId) return candidates[0]!.index;
  for (const { product, index } of candidates) {
    const ids = await loadTemplateIds(product.id);
    if (ids.includes(mockupId)) return index;
  }
  return candidates[0]!.index;
}
